<template>
  <div>
    <div v-if="isLoading" class="content-spinner">
      <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
    </div>

    <v-form v-else ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit(item)">
      <v-container>
        <v-row>
          <v-col class="text-center" cols="12" sm="4" md="3" lg="3" xl="3">
            <v-avatar size="128" class="mt-3">
              <img src="../../assets/no-img.svg" alt="" />
            </v-avatar>
          </v-col>
          <v-col cols="12" sm="8" md="9" lg="9" xl="9">
            <v-text-field
              v-model="item.user.firstName"
              type="text"
              label="First Name"
              :rules="firstNameRules"
              :error-messages="isInvalid('firstName') ? violations.firstName : []"
              @input.native="handleUpdateField('firstName', $event.target.value)"
            ></v-text-field>
            <v-text-field
              v-model="item.user.lastName"
              type="text"
              label="Last Name"
              :rules="lastNameRules"
              :error-messages="isInvalid('lastName') ? violations.lastName : []"
              @input.native="handleUpdateField('lastName', $event.target.value)"
            ></v-text-field>
            <v-text-field
              v-model="item.user.username"
              type="text"
              label="Username"
              hint="The username must be lowecase alphanumeric, without spaces or symbols"
              :rules="usernameRules"
              :error-messages="isInvalid('username') ? violations.username : []"
              @input.native="handleUpdateField('username', $event.target.value)"
            ></v-text-field>
            <v-text-field
              v-model="item.user.email"
              type="email"
              label="Email"
              hint="Enter a valid email address"
              :rules="emailRules"
              :error-messages="isInvalid('email') ? violations.email : []"
              @input.native="handleUpdateField('email', $event.target.value)"
            ></v-text-field>
            <!--
            <v-checkbox
              label="enabled"
              hint="Whether this user is enabled/disabled"
              v-model="item.user.enabled"
              :error-messages="isInvalid('enabled') ? violations.enabled : []"
              @change.native="handleUpdateField('enabled', $event.target.value)"
            ></v-checkbox>
            -->
            <v-select
              v-model="item.vesselRole"
              :items="vesselRoles"
              item-value="@id"
              item-text="name"
              label="Role in vessel"
              single-line
              :rules="vesselRoleRules"
              :error-messages="isInvalid('vesselRole') ? violations.vesselRole : []"
              @change.native="handleUpdateField('vesselRole', $event.target.value)"
            ></v-select>

            <input type="submit" hidden />
            <v-btn v-if="item['@id']" text color="red" @click="deleteConfirmShow = true">Delete</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-dialog v-model="deleteConfirmShow" max-width="400">
      <v-card>
        <v-card-title class="headline">Delete {{ item.id }}?</v-card-title>
        <v-card-text>
          Are you sure you want to delete {{ item.id }}? <br /><br />
          The deleted data <strong>can't be recovered</strong>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="grey darken-1" text @click.native="onDeleteCancel">Cancel</v-btn>
          <v-btn color="red" text @click.native="onDeleteConfirm">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    handleDelete: {
      type: Function,
      required: false,
      default: () => {}
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      deleteConfirmShow: false,
      valid: true,
      firstNameRules: [v => (!!v && !!v.trim()) || 'First name is required'],
      lastNameRules: [v => (!!v && !!v.trim()) || 'Last name is required'],
      usernameRules: [
        v => {
          return !!v || 'Username is required'
        },
        v => {
          return (v && v.length <= 32) || 'Username must be less than 32 characters'
        },
        v => {
          return (v && v.length >= 4) || 'Username must be more than 4 characters'
        },
        v => {
          return (
            /^[a-z0-9_.]*$/.test(v) ||
            'Username must be lowercase and contain only letters, numbers, dots and underscores'
          )
        }
      ],
      emailRules: [
        v => (!!v && !!v.trim()) || 'Email is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      vesselRoleRules: [v => (!!v && !!v.trim()) || 'Role in vessel is required']
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations() {
      return this.errors || {}
    },

    ...mapGetters({
      vesselRoles: 'vesselrole/list/items',
      isLoading: 'vesselrole/list/isLoading'
    })
  },

  created() {
    this.getVesselRoles('/vessel_roles?pagination=false')
  },

  methods: {
    isInvalid(key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },

    onDeleteConfirm() {
      this.deleteConfirmShow = false
      this.handleDelete()
    },

    onDeleteCancel() {
      this.deleteConfirmShow = false
    },

    onSubmit(item) {
      if (this.$refs.form.validate()) {
        this.handleSubmit(item)
      }
    },

    ...mapActions({
      getVesselRoles: 'vesselrole/list/default'
    })
  }
}
</script>
